import React, { useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { useQuery } from 'react-query'
import { getPostman } from '../../../Api'
import styles from './styles.module.css'
import ColorAlert from '../../Snackbar/NewImplementations/ColorAlert/ColorAlert' // ← add this

function ApiSettings () {
  const user = localStorage.getItem('dfp/session')
  const { data: postmanDataCollection } = useQuery('postman', getPostman)

  // New state for copy‐token alert
  const [copyAlertOpen, setCopyAlertOpen] = useState(false)

  const downloadAString = () => {
    const file = JSON.stringify(postmanDataCollection?.data, null, 3)
    const blob = new Blob([file], { type: 'text/plain;charset=utf-8' })
    const a = window.document.createElement('a')
    a.href = window.URL.createObjectURL(blob)
    a.download = 'datafiniti_postman_collection.json'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  return (
    <section style={{ marginTop: '18px' }}>
      <h1 className={styles.titleApiSettings}>API</h1>
      <span className={styles.tokenSpanApiSettings}>Token</span>
      <input
        className={styles.inputApiSettings}
        type='text'
        value={user || 'null'}
        readOnly
      />
      <div className={styles.containerButtonsApiSettings}>
        <CopyToClipboard text={user} onCopy={() => setCopyAlertOpen(true)}>
          <button className={styles.buttonCopyApiSettings}>Copy token</button>
        </CopyToClipboard>

        <button
          onClick={downloadAString}
          className={styles.buttonCopyApiSettings}
        >
          Get Postman Collection
        </button>
      </div>

      {/* replace SnackbarComponent with ColorAlert for the copy action */}
      <ColorAlert
        open={copyAlertOpen}
        type='success'
        label='Copied token'
        onClose={() => setCopyAlertOpen(false)}
        style={{ bottom: 20 }}
      />
    </section>
  )
}

export default ApiSettings
